module.exports = __webpack_public_path__ + "img/hohlsaum_koenigsblau_farbnr543.09e3242e.jpg";